module.exports = __webpack_public_path__ + "img/OrgChartTemp4.46dab0cf.png";